import { useState } from "react";
import { isEqual } from "lodash";

import { SortByQuickFilter } from "./interfaces";
import { ListSortDirection } from "../../../models/api/sort";

export const useSortByQuickFilter = () => {
  const [quickFilter, setQuickFilter] = useState<SortByQuickFilter>({
    sortByOptions: {
      sortBy: [{ name: "date", direction: ListSortDirection.Descending }],
    },
  });

  const handleChangeQuickFilter = (filter: keyof SortByQuickFilter, value: SortByQuickFilter["sortByOptions"]) => {
    if (isEqual(value, quickFilter[filter])) return;

    setQuickFilter((state) => ({ ...state, [filter]: value }));
  };

  return {
    sortByQuickFilter: quickFilter,
    setSortByQuickFilter: handleChangeQuickFilter,
  };
};
